import { styled, Select } from '@cherre-frontend/ui';

export const StyledSelect = styled(Select)<{
  borderColor: string;
  fontColor: string;
  width: string;
}>`
  height: 100%;
  width: ${({ width }) => width};
  color: ${({ theme }) => theme.palette.grey['100']};

  & .MuiFormLabel-root {
    font-size: inherit;
  }

  & .MuiSelect-select {
    color: ${({ fontColor }) => fontColor};
  }

  & .MuiOutlinedInput-notchedOutline {
    border-color: ${({ borderColor }) => borderColor} !important;
    border-radius: 6px;
  }

  svg {
    color: ${({ theme }) => theme.palette.primary.light};
  }

  & legend {
    height: 15px;
    & > span {
      color: ${({ fontColor }) => fontColor};
      opacity: 1;
    }
  }
`;

export const ListItemContentContainer = styled('div')`
  display: flex;
  gap: 8px;
`;
